import { AiOutlineLock, AiOutlineTeam } from "react-icons/ai";
import { UserType } from "src/shared/constants/AppConst";
import { GoPackage, GoTasklist } from "react-icons/go";
import { BsBuildings } from "react-icons/bs";
import { RiBuilding2Line } from "react-icons/ri";
import {
  ManageCasePricing,
  ManageCases,
  ManageCaseTreatmentMaterial,
  ManageCodes,
  ManageCompany,
  ManageAgentCompany,
  ManageCashPayment,
  ManageDoctorStatistics,
  ManagePackages,
  ManagePatients,
  ManagePlannerStatistics,
  ManageFabricatorStatistics,
  ManageCoordinatorStatistics,
  ManagePriceBrackets,
  ManageRoles,
  ManageTestQuestion,
  ManageTreatmentColor,
  ManageTreatments,
  ManageTreatmentType,
  ManageUser,
} from "src/shared/constants/permissions-enum";
import { MdColorLens, MdOutlineMedicalInformation } from "react-icons/md";
import { FaUsersCog } from "react-icons/fa";
import { TbTag, TbReportMoney, TbChartBar } from "react-icons/tb";
import { MdDashboard } from "react-icons/md";

const routesConfig = [
  {
    id: "agent-company-dashboard",
    title: "agent-company-dashboard",
    messageId: "agentDashboard.sideBarName",
    icon: <MdDashboard />,
    type: "item",
    path: "/agent-company-dashboard",
    permissionKey: ManageDoctorStatistics.View,
    userTypeKey: UserType.AgentCompany,
  },
  {
    id: "cash-payment-report",
    title: "cash-payment-report",
    messageId: "cashPayment.sideBarName",
    icon: <TbReportMoney />,
    type: "item",
    path: "/cash-payment-report",
    permissionKey: ManageCashPayment.View,
  },
  {
    id: "statisticsAll",
    title: "statisticsAll",
    messageId: "statistics.sideBarName",
    icon: <TbChartBar />,
    type: "group",
    permissionKey: [
      ManageAgentCompany.List,
      ManagePlannerStatistics.View,
      ManageFabricatorStatistics.View,
      ManageCoordinatorStatistics.View,
    ],
    children: [
      {
        id: "agent-company-statistics",
        title: "agent-company-statistics",
        messageId: "agentCompanyStats.sideBarName",
        type: "item",
        path: "/agent-company-statistics",
        permissionKey: ManageAgentCompany.List,
      },
      {
        id: "planner-statistics",
        title: "planner-statistics",
        messageId: "plannerStats.sideBarName",
        type: "item",
        path: "/planner-statistics",
        permissionKey: ManagePlannerStatistics.View,
      },
      {
        id: "fabricator-statistics",
        title: "fabricator-statistics",
        messageId: "fabricatorStats.sideBarName",
        type: "item",
        path: "/fabricator-statistics",
        permissionKey: ManageFabricatorStatistics.View,
      },
      {
        id: "coordinator-statistics",
        title: "coordinator-statistics",
        messageId: "coordinatorStats.sideBarName",
        type: "item",
        path: "/coordinator-statistics",
        permissionKey: ManageCoordinatorStatistics.View,
      },
    ],
  },
  {
    id: "companies",
    title: "companies",
    messageId: "companies.sideBarName",
    icon: <BsBuildings />,
    type: "item",
    path: "/companies",
    permissionKey: ManageCompany.List,
  },
  {
    id: "agent-companies",
    title: "agent-companies",
    messageId: "agentCompanies.sideBarName",
    icon: <RiBuilding2Line />,
    type: "item",
    path: "/agent-companies",
    permissionKey: ManageAgentCompany.List,
  },
  {
    id: "questions",
    title: "questions",
    messageId: "questionsManagement.sideBarName",
    icon: <GoTasklist />,
    type: "item",
    path: "/questions",
    permissionKey: ManageTestQuestion.List,
  },
  {
    id: "roles",
    title: "roles",
    messageId: "rolesManagement.sideBarName",
    icon: <AiOutlineLock />,
    type: "item",
    path: "/roles",
    permissionKey: ManageRoles.List,
  },
  {
    id: "usersAll",
    title: "usersAll",
    messageId: "common.usersAll",
    icon: <FaUsersCog />,
    type: "group",
    permissionKey: ManageUser.List,
    children: [
      {
        id: "clients",
        title: "clients",
        messageId: "clientsManagement.sideBarName",
        type: "item",
        path: "/clients",
        permissionKey: ManageUser.List,
      },
      {
        id: "users",
        title: "users",
        messageId: "usersManagement.sideBarName",
        type: "item",
        path: "/users",
        permissionKey: ManageUser.List,
      },
    ],
  },
  {
    id: "patients",
    title: "patients",
    messageId: "patient.sideBarName",
    icon: <AiOutlineTeam />,
    type: "item",
    path: "/patients",
    permissionKey: ManagePatients.List,
  },
  {
    id: "packages",
    title: "packages",
    messageId: "packages.sideBarName",
    icon: <GoPackage />,
    type: "item",
    path: "/packages",
    permissionKey: ManagePackages.List,
  },
  {
    id: "case-pricing",
    title: "case-pricing",
    messageId: "casePricing.sideBarName",
    icon: <TbReportMoney />,
    type: "item",
    path: "/case-pricing",
    permissionKey: ManageCasePricing.List,
  },
  {
    id: "case-treatment-material",
    title: "case-treatment-material",
    messageId: "caseTreatmentMaterial.sideBarName",
    icon: <MdOutlineMedicalInformation />,
    type: "item",
    path: "/case-treatment-material",
    permissionKey: ManageCaseTreatmentMaterial.List,
  },
  {
    id: "treatment-color",
    title: "treatment-color",
    messageId: "treatmentColor.sideBarName",
    icon: <MdColorLens />,
    type: "item",
    path: "/treatment-colors",
    permissionKey: ManageTreatmentColor.List,
  },
  {
    id: "treatment-type",
    title: "treatment-type",
    messageId: "treatmentType.sideBarName",
    icon: <MdOutlineMedicalInformation />,
    type: "item",
    path: "/treatment-types",
    permissionKey: ManageTreatmentType.List,
  },
  {
    id: "promo-codes",
    title: "promo-codes",
    messageId: "promoCodes.sideBarName",
    icon: <TbTag />,
    type: "item",
    path: "/promo-codes",
    permissionKey: ManageCodes.List,
  },
  {
    id: "price-brackets",
    title: "price-brackets",
    messageId: "priceBrackets.sideBarName",
    icon: <TbReportMoney />,
    type: "item",
    path: "/price-brackets",
    permissionKey: ManagePriceBrackets.List,
  },
  {
    id: "treatmentsAll",
    title: "treatmentsAll",
    messageId: "treatment.sideBarName",
    icon: <MdOutlineMedicalInformation />,
    type: "group",
    permissionKey: [
      ManageTreatments.List,
      ManageTreatments.ActionNeededTreatments,
      ManageTreatments.ArchivedTreatments,
      ManageTreatments.ViewOnGoingTreatments,
    ],
    children: [
      {
        id: "treatments",
        title: "treatments",
        messageId: "treatment.sideBarName",
        type: "item",
        path: "/treatments",
        permissionKey: ManageTreatments.List,
      },
      {
        id: "treatments-action-needed",
        title: "treatments-action-needed",
        messageId: "treatment.actionNeeded",
        type: "item",
        path: "/treatments-action-needed",
        permissionKey: ManageTreatments.ActionNeededTreatments,
      },
      {
        id: "treatments-archived",
        title: "treatments-archived",
        messageId: "treatment.archived",
        type: "item",
        path: "/treatments-archived",
        permissionKey: ManageTreatments.ArchivedTreatments,
      },
      {
        id: "treatments-on-going",
        title: "treatments-on-going",
        messageId: "treatment.onGoing",
        type: "item",
        path: "/treatments-on-going",
        permissionKey: ManageTreatments.ViewOnGoingTreatments,
      },
    ],
  },
  {
    id: "casesAll",
    title: "casesAll",
    messageId: "cases.sideBarName",
    icon: <MdOutlineMedicalInformation />,
    type: "group",
    permissionKey: [
      ManageCases.List,
      ManageCases.ActionNeededCases,
      ManageCases.ArchivedCases,
      ManageCases.ViewOnGoingCases,
    ],
    children: [
      {
        id: "cases",
        title: "cases",
        messageId: "cases.sideBarName",
        type: "item",
        path: "/cases",
        permissionKey: ManageCases.List,
      },
      {
        id: "cases-action-needed",
        title: "cases-action-needed",
        messageId: "cases.actionNeeded",
        type: "item",
        path: "/cases-action-needed",
        permissionKey: ManageCases.ActionNeededCases,
      },
      {
        id: "cases-archived",
        title: "cases-archived",
        messageId: "cases.archived",
        type: "item",
        path: "/cases-archived",
        permissionKey: ManageCases.ArchivedCases,
      },
      {
        id: "cases-on-going",
        title: "cases-on-going",
        messageId: "cases.onGoing",
        type: "item",
        path: "/cases-on-going",
        permissionKey: ManageCases.ViewOnGoingCases,
      },
    ],
  },
];
export default routesConfig;
